// blockquote, code block and inline code were removed from the editor schema, so the parser would
// drop them from an older document without a word. The trailing character class stops `<pre`
// matching a longer tag name.
const UNSUPPORTED_TAGS = /<(blockquote|pre|code)[\s>/]/i;

/** Checked on the stored html, before it reaches the editor - the parse itself gives no signal. */
const hasUnsupportedMarkup = (html: string | undefined): boolean => !!html && UNSUPPORTED_TAGS.test(html);

export default hasUnsupportedMarkup;
